import React from 'react';
import { Hero } from '../components/Hero';
import { WhatIsForge } from '../components/WhatIsForge';
import { PathsSection } from '../components/PathsSection';
import { ResultsSection } from '../components/ResultsSection';
import { PhilosophySection } from '../components/PhilosophySection';
import { StoriesSection } from '../components/StoriesSection';
import { PodcastSection } from '../components/PodcastSection';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <div className="w-full" data-id="element-208">
      <Hero data-id="element-209" />
      <WhatIsForge data-id="element-210" />
      <PathsSection data-id="element-211" />
      <ResultsSection data-id="element-212" />
      <PhilosophySection data-id="element-213" />
      <StoriesSection data-id="element-214" />
      <PodcastSection data-id="element-215" />
      <FinalCTA data-id="element-216" />
    </div>;
}